export default {
  en: {
    supplementChargeList: 'Supplement Charge List',
    newSupplementCharge: 'New Supplement Charge',
    name: 'Name',
    type: 'Type',
    pleaseSelectType: 'Please select type',
    otherType: '- Other -',
    rate: 'Rate',
    unit: 'Unit',
    inRomRate: 'In room rate',
    yes: 'Yes',
    no: 'No',
    periodOfStay: 'Period of Stay',
    addPeriod: 'Add Period',
    conditionDetail: 'Condition Detail',
    createSupplementCharge: 'Create Supplement Charge',
    cancel: 'Cancel',
    createSupplementChargeSuccessTitle: 'Success',
    createSupplementChargeSuccessMessage: 'Create supplement charge success.',
    pleaseSelectPeriodOfStay: 'Please select period of stay',
    alertOverlap: 'Period is Overlap',
    allTheTime: 'All'
  },
  th: {
    supplementChargeList: 'รายการเพิ่มเติม',
    newSupplementCharge: 'สร้างรายการเพิ่มเติม',
    name: 'ชื่อ',
    type: 'ประเภท',
    pleaseSelectType: 'กรุณาเลือกประเภท',
    otherType: '- อื่นๆ -',
    rate: 'ราคา',
    unit: 'หน่วย',
    inRomRate: 'รวมในราคาห้อง',
    yes: 'รวม',
    no: 'ไม่รวม',
    periodOfStay: 'ช่วงเวลา',
    addPeriod: 'เพิ่มช่วงเวลา',
    conditionDetail: 'รายละเอียด',
    createSupplementCharge: 'สร้างรายการเพิ่มเติม',
    cancel: 'ยกเลิก',
    createSupplementChargeSuccessTitle: 'สำเร็จ',
    createSupplementChargeSuccessMessage: 'สร้างรายการเพิ่มเติมสำเร็จ',
    pleaseSelectPeriodOfStay: 'กรุณาเลือกช่วงเวลา',
    alertOverlap: 'ช่วงเวลาซ้อนทับกัน',
    allTheTime: 'ตลอดระยะสัญญา'
  }
}
